<template>
    <div id="archive-confirmation" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Confirm Claim Archiving</h5>
                </div>
                <div class="modal-body">
                    <div class="mb-2">
                        <div class="h5 font-weight-bold text-center">
                            Are you sure you want to archive this claim?
                        </div>
                        <div class="p-2">
                            <span class="warning-label"><i class="fas fa-exclamation-triangle text-warning"></i> WARNING:</span>
                            <span class="warning-text">
                                Once a claim has been archived you will not be able to view many of the claim details
                                without first unarchiving the claim.
                            </span>
                        </div>
                    </div>                  
                    <div class="form-group">
                        <label for="archiveNote">Archive Note <small class="text-muted"><em>(Optional)</em></small>:</label>
                        <textarea id="archiveNote" class="form-control" v-model="note" autofocus></textarea>
                    </div>                    
                </div>
                <div class="modal-footer text-center">
                    <button type="button" class="btn btn-danger" @click="onConfirm()" data-dismiss="modal">Archive</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>
    </div>     
</template>

<script>
export default {
    data() { 
        return {
            id: null,
            note: null
        }
    },
    methods: {
        show: function (id) {
            this.id = id;
            $('#archive-confirmation').modal('show');
        },
        onConfirm: function (value) {
            this.$emit('confirm', this.id, this.note);
        }
    },
    created() {
        eventHub.$on('show-archive-confirmation', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-archive-confirmation');
    }       
}
</script>

<style scoped>
    .fa-exclamation-triangle.text-warning {
        background:linear-gradient(#000,#000) center bottom/20% 84% no-repeat;
    }

    .warning-label {
        font-weight: bold;     
    }
    .warning-text {
        font-weight: bold;
        font-size: .95em;
        /* line-height: 1em; */
    }    
</style>